<!-- 座席状态 -->
<template>
  <div id="agentStatus" class="border-div" style=""></div>
</template>

<script>
  export default {
    name: "agentStatus",
    data() {
      return {
        // 座席状态
        agentStatusData: [{
            value: 0,
            name: "通话中"
          },
          {
            value: 0,
            name: "空闲"
          },
          {
            value: 0,
            name: "忙碌"
          },
          {
            value: 0,
            name: "离线"
          },
          {
            value: 0,
            name: "其他"
          }
        ], //座席状态数据
        timeFlag: '',  //定时器标识
        pieChart: null,
      }
    },
    created() {
      this.getAgentStatus();
      this.timeFlag = setInterval(this.getAgentStatus, 5000);
      
    },
    methods: {
        // 座席状态
      getAgentStatus() {
        let that = this;
        let param = {
          journalType: null,
          menuId: null
        };
        this.$http.post("bigScreen/toEmpStatusIndex.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }

          that.agentStatusData = res.data.obj.list;
          that.handleBottomLeftEchart(); // 左下饼图
        });
      },

      // 处理左下饼图
      handleBottomLeftEchart() {
        let that = this;
        // 1.实例化对象
        that.pieChart = this.$echarts.init(
          document.getElementById("agentStatus")
        );
        // 2.把配置项给实例对象
        that.pieChart.setOption({
          color: [
            "#27e9cb",
            "#236bd7",
            "#fed130",
            "#8c8887",
            "#fd895b",
          ],
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            orient: "vertical",
            // left:8,
            left:30,
            y:'center',
            data: ["通话中", "空闲", "忙碌", "离线", "其他"],
            textStyle: {
              color: "rgba(255,255,255,.8)",
              fontSize: 16,
            }
          },
          series: [{
            name: "座席状态",
            type: "pie",
            radius: ["30%", "45%"],
            avoidLabelOverlap: true,
            center: ["65%", "50%"],
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold",
              }
            },
            label: {
              fontSize: 16,
              position: 'outer',
              alignTo: 'none',
            },
            itemStyle: {
              normal: {
                label: { //此处为指示线文字
                  show: true,
                  textStyle: {
                    fontWeight: 200,
                    fontSize: 16 //文字的字体大小
                  },
                  formatter: '{c}' //指示线对应文字
                },
                // 链接图形和文字的线条
                labelLine: {
                  // length 链接图形的线条
                  length: 20,
                  // length2 链接文字的线条
                  length2: 22
                },
              }
            },
            data: this.agentStatusData,
          }]
        });
        // window.addEventListener("resize", function () {
        //   pieChart.resize();
        // });
      },
    },
    beforeDestroy() {
      if(this.timeFlag){
         clearInterval(this.timeFlag);
      }
      this.pieChart = null;
      this.getAgentStatus = null;
      this.handleBottomLeftEchart = null;
      this.$echarts = null;
    },
    destroyed() {
      
    },
  }
</script>
<style scoped lang="less">
@import "../../assets/css/daping.less";
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/agentStatus.vue